/** An acknowledged pending batch must retain its request identity until resumed. */
export function recurringBatchState(value: unknown, requestId: string, organizationId: string): "completed" | "pending" {
  if (!value || typeof value !== "object") throw new Error("Invalid recurring batch response");
  const batch = value as Record<string, unknown>;
  if (batch.requestId !== requestId || batch.organizationId !== organizationId || batch.automaticPaymentEnabled !== false ||
      !["PENDING", "COMPLETED"].includes(batch.state as string) || !Array.isArray(batch.items) || batch.items.length > 1) {
    throw new Error("Invalid recurring batch response");
  }
  return batch.state === "PENDING" ? "pending" : "completed";
}
